import TableList from "@components/templates/tablelist";
import {
    HttpUserList,
    HttpSetUserStatus
} from "@/service/ucadm";

import { mapGetters } from 'vuex';
export default {
    mixins: [TableList],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                isEnterSearch: true,
                show: true,
                labelWidth: 90
            },
            Plugins: { show: true }
        };
    },
    methods: {
        ajaxRequest: HttpUserList,
        handleOperates(params = "", type, batch) {
            if (batch) {
                params = (params || this.checkedData.join(",")) + "";
                if (!params.length)
                    return this.$VMessage.warning("请选择至少一条数据");
            }
            switch (type) {
                case "add":
                    this.$router.push({
                        name: "userUpdate",
                        params: { type },
                    });
                    break;
                case "edit":
                    this.$router.push({
                        name: "userUpdate",
                        params: { type },
                        query: { id: params }
                    });
                    break;
                case "setStatus":
                    this.operate = {
                        show: true,
                        alert: "primary",
                        params,
                        title: (params.status == 0 ? "禁用" : "启用") + "该用户",
                        ajaxRequest: HttpSetUserStatus
                    };
                    break;
            }
        },
        getOperateNodeMap(row) {
            const { id, status } = row;
            return [
                {
                    label: "编辑",
                    show: true,
                    params: id,
                    operate: "edit",
                    show: row.status == 1
                },
                {
                    label: status == 1 ? "禁用" : "启用",
                    show: true,
                    params: { id, status: status == 1 ? 0 : 1 },
                    operate: "setStatus"
                }
            ];
        }
    },
    computed: {
        ...mapGetters('ucadm', ['getSysList']),
        ToolsData() {
            return [{
                label: '添加用户',
                operate: 'add',
                theme: 'primary',
                show: this.handleAuth('uc.user.add')
            }]
        },
        SearchsData() {
            return [
                {
                    label: "用户名称",
                    tag: "vInput",
                    key: "CN_name",
                    show: true
                },
                {
                    label: "邮箱",
                    tag: "vInput",
                    key: "CN_email",
                    show: true
                },
                {
                    label: "组织",
                    tag: "vSelect",
                    key: "EQ_orgId",
                    show: true,
                    props: {
                        dropStyle: "width:auto;",
                        filterable: true
                    },
                    options: this.getSysList
                },
                {
                    label: "状态",
                    tag: "vSelect",
                    key: "EQ_status",
                    show: true,
                    options: [
                        {
                            label: "所有",
                            value: ""
                        },
                        {
                            label: "激活",
                            value: "1"
                        },
                        {
                            label: "未激活",
                            value: "0"
                        }
                    ]
                }
            ];
        },
        columns() {
            return [
                {
                    title: "操作",
                    width: 70,
                    render: this.getOperateNodes
                },
                {
                    title: "用户名称",
                    key: "name",
                    sortable: true
                },
                {
                    title: "邮箱",
                    key: "email",
                    sortable: true
                },
                {
                    title: "状态",
                    key: "status",
                    render(h, { row }) {
                        const bool = row.status == 1;
                        return (
                            <vButton theme={bool ? "success" : "error"} ghost>
                                {bool ? "激活" : "未激活"}
                            </vButton>
                        );
                    }
                },
                {
                    title: "最后登录时间",
                    key: "lastLoginTime"
                },
                {
                    title: "更新时间",
                    key: "updatedAt"
                }
            ];
        }
    }
};
